import { Link } from "react-router-dom";
import { Lightning } from "@phosphor-icons/react";

export default function Footer() {
  return (
    <footer className="border-t border-white/10 mt-32 bg-[#05050A]">
      <div className="max-w-[1400px] mx-auto px-5 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-5">
            <div className="w-9 h-9 bg-[#FFEB3B] flex items-center justify-center rounded-sm">
              <Lightning weight="fill" size={22} className="text-[#05050A]" />
            </div>
            <span className="font-display font-black text-lg tracking-tighter">D&J's Comedy Club</span>
          </div>
          <p className="text-white/50 max-w-md leading-relaxed">
            Themes and things for people whose home screens are funnier than their group chats.
            Aesthetic icon packs, glowing widgets, and matching wallpapers.
          </p>
        </div>
        <div>
          <h4 className="font-display uppercase text-xs tracking-[0.2em] text-white/40 mb-4">Explore</h4>
          <ul className="space-y-3 text-white/60">
            <li><Link to="/marketplace" className="hover:text-[#00E5FF] transition-colors">Marketplace</Link></li>
            <li><Link to="/comedy" className="hover:text-[#00E5FF] transition-colors">Comedy</Link></li>
            <li><Link to="/premium" className="hover:text-[#00E5FF] transition-colors">Premium</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-display uppercase text-xs tracking-[0.2em] text-white/40 mb-4">The Bit</h4>
          <p className="text-white/50 text-sm leading-relaxed">
            Every download is a punchline. No refunds on jokes that don't land.
          </p>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 text-center text-white/30 text-xs tracking-wider">
        © {new Date().getFullYear()} D&J'S COMEDY CLUB THEMES AND THINGS — ALL LAUGHS RESERVED
      </div>
    </footer>
  );
}
